require('./navigation.js');
require('./custom.js');

//Slick-slider
//require('slick-carousel/slick/slick.js');

//FontAwesome All in one file
//require('@fortawesome/fontawesome-pro/js/all.js');

//FontAwesome parts

// Core
require('@fortawesome/fontawesome-pro');
import { library as FontAwesomeLibrary, config, dom } from '@fortawesome/fontawesome-svg-core';
config.autoA11y = true;
config.observeMutations = true;
config.autoReplaceSvg = true;

import { faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faShoppingCart, faMapMarkerAlt, faSearch} from '@fortawesome/pro-solid-svg-icons';
import { faHomeLgAlt, faBars, faTimes } from '@fortawesome/pro-regular-svg-icons';


FontAwesomeLibrary.add(faHomeLgAlt, faTimes, faBars, faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin, faEnvelope, faPhone, faShoppingCart, faMapMarkerAlt, faSearch);

dom.watch();

/*
Ikonikirjastot:
free-brands-svg-icons
pro-light-svg-icons
pro-regular-svg-icons
pro-solid-svg-icons
*/


// Brands
//require('@fortawesome/fontawesome-pro/js/brands.js');

// Light
//require('@fortawesome/fontawesome-pro/js/light.js');

// Regular
//require('@fortawesome/fontawesome-pro/js/regular.js');

// Solid
//require('@fortawesome/fontawesome-pro/js/solid.js');

// v4-shims
//require('@fortawesome/fontawesome-pro/js/v4-shims.js');

jQuery('document').ready(function($){
  $('.icon button').on('click touchstart', function() {
    $(this).find('svg').toggleClass('fa-bars fa-times');
  });
});
